import React from 'react';
import {SelectInput} from '~/components/Controls/Select';
import {IAttributeInfo, IOperation} from '~/modules/Bidders/models/Rule';

interface IOperationSelectProps {
    attribute: IAttributeInfo;
    operation: IOperation;
    onChange: (operation: IOperation) => void;
}

export const OperationSelect = (props: IOperationSelectProps) => <SelectInput
    value={props.operation}
    clearable={false}
    items={props.attribute.ops.map(operation => ({
        value: operation,
        label: operation
    }))}
    onChange={option => props.onChange(option)}
/>;
